/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const SoccerCardCountGuide: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character"/>
  const title = (
    <p className="guide-txt big">
      카드 수 계산법
    </p>
  )
  const body = (
    <div className="guide-box small thin">
      카드 수는 경기 진행중에 발생한 카드를 기준으로 하며,<br/>
      모든 카드는 1장으로 계산합니다.<br/>
      단, 경고 누적이 없는 선수가 다이렉트로 레드카드를<br/>
      받은 경우에 한하여 2장으로 계산합니다.
      <span className="line"/>
      <div className="point-color--orange--modal thin">
        경기를 뛰고 있지 않은 선수(이미 교체된 선수, 감독,<br/>
        후보선수 등)에게 발생한 카드는 포함하지 않습니다.
      </div>
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
